import { useEffect, useState } from 'react';

/**
 * SSR-safe `matchMedia` subscription. Returns `false` until the listener
 * fires once on mount, so server-rendered output is deterministic. Used by
 * the Code Quality distribution-column panels to pick the default top-N
 * (top-5 below the `sm` breakpoint, top-10 above) — see PRODOPSAI-333 spec
 * D18 row.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (globalThis.window === undefined || typeof globalThis.matchMedia !== 'function') {
      return;
    }
    const mql = globalThis.matchMedia(query);
    setMatches(mql.matches);

    const listener = (event: MediaQueryListEvent) => setMatches(event.matches);
    mql.addEventListener('change', listener);
    return () => mql.removeEventListener('change', listener);
  }, [query]);

  return matches;
}
